export default "__VITE_ASSET__84ee5fa1__"